// src/services/employeeService.js
import { apiService } from './api';

export const employeeService = {
  // Récupérer tous les employés de l'entreprise
  async getEmployees() {
    const response = await apiService.get('/employees');
    return response.data;
  },

  // Créer un nouvel employé
  async createEmployee(employeeData) {
    const response = await apiService.post('/employees', employeeData);
    return response.data;
  },

  // Récupérer un employé spécifique
  async getEmployee(id) {
    const response = await apiService.get(`/employees/${id}`);
    return response.data;
  },

  // Mettre à jour un employé
  async updateEmployee(id, employeeData) {
    const response = await apiService.put(`/employees/${id}`, employeeData);
    return response.data;
  },

  // Supprimer un employé
  async deleteEmployee(id) {
    const response = await apiService.delete(`/employees/${id}`);
    return response;
  },
  async resetPassword(id) {
    const response = await apiService.put(`/employees/${id}/reset-password`);
    return response.data;
  }
};